export default __webpack_public_path__ + "media/runs-on-atlassian.834f1db5162fa87994c0f2992ff69d45.svg";